/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getProgramSheet} from '../api'

 export const useQueryGetProgramSheet = createReactQueryHook('getProgramSheet', getProgramSheet)
